(() => {
  if (window.__luceMaterialsReady) return;
  window.__luceMaterialsReady = true;

  const reveal = () => {
    const nodes = document.querySelectorAll('[data-mat-reveal]:not(.is-visible)');
    if (!('IntersectionObserver' in window)) {
      nodes.forEach((node) => node.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    nodes.forEach((node) => observer.observe(node));
  };

  const parallax = () => {
    const hero = document.querySelector('[data-mat-parallax]');
    if (!hero || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let ticking = false;
    const update = () => {
      const rect = hero.getBoundingClientRect();
      const offset = Math.max(-36, Math.min(36, -rect.top * 0.055));
      hero.style.setProperty('--mat-parallax', `${offset}px`);
      ticking = false;
    };
    addEventListener('scroll', () => {
      if (ticking) return;
      requestAnimationFrame(update);
      ticking = true;
    }, { passive: true });
    update();
  };

  const init = () => { reveal(); parallax(); };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init, { once: true }) : init();
  document.addEventListener('shopify:section:load', reveal);
})();
